// extracted by mini-css-extract-plugin
export default {"wrapper":"ctaBlock__wrapper--MK4zc","image":"ctaBlock__image--O9ZNE","text":"ctaBlock__text--QMNaw"};